import React from 'react'
import PropTypes from 'prop-types'
import {
  MUTUAL_FUND,
  ETF_FUND,
  ETF_INDEX_FUND,
  VARIABLE_FUND,
  FUTURE_SCHOLAR_529,
  CLOSED_END_FUND,
  INTERVAL_FUND,
} from '../../Helpers/FundTypes.js'
import VariableFundDisclosure from '../../Helpers/VariableFundDisclosure.js'
function PerformanceDisclosures({ growthOf10K, fundGroup, fundName }) {
  const hasGrowthOf10K = growthOf10K?.value?.product?.asOfDate

  return (
    <div id="performance-module-disclosure" className="u-paddingBottom12gu">
      <div className="Disclaimer">
        {fundGroup === MUTUAL_FUND && (
          <React.Fragment>
            <h5 className="Disclaimer-heading">Performance Disclosures</h5>
            {hasGrowthOf10K && (
              <p className="Disclaimer-text">
                Growth of $10,000 investment illustration is based on a
                hypothetical $10,000 investment, not including sales charges.
                Had sales charges been included, returns would be lower. All
                results shown assume reinvestment of dividends and capital
                gains.
              </p>
            )}
            <p className="Disclaimer-text">
              Performance data shown represents past performance and is not a
              guarantee of future results. The investment return and principal
              value of an investment will fluctuate so that shares, when
              redeemed, may be worth more or less than their original cost.
              Current performance may be lower or higher than the performance
              data shown. Returns shown assume reinvestment of distributions and
              do not reflect the deduction of taxes that a shareholder would pay
              on fund distributions or the redemption of fund shares.
            </p>
            <p className="Disclaimer-text">
              * Returns shown for periods prior to the fund&apos;s share class
              inception date include the returns of the oldest share class of
              the fund, adjusted to reflect higher class-related operating
              expenses, as applicable. In addition, the returns shown include
              the returns of any predecessor to the fund. For certain funds,
              performance reflects returns achieved through an investment
              strategy which materially differs from the strategy currently
              utilized. Click{' '}
              <a
                className="Link"
                href="/investment-products/mutual-funds/appended-performance/"
              >
                here
              </a>{' '}
              for more information.
            </p>
          </React.Fragment>
        )}

        {(fundGroup === ETF_FUND || fundGroup === ETF_INDEX_FUND) && (
          <React.Fragment>
            <h5 className="Disclaimer-heading">Performance Disclosures</h5>
            <p className="Disclaimer-text">
              Growth of $10,000 investment illustration is based on a
              hypothetical $10,000 investment calculated at Net Asset Value
              (NAV). If calculated at Market Price, returns would be lower. All
              results shown assume reinvestment of dividends and capital gains.
            </p>

            <p className="Disclaimer-text">
              The performance data quoted above represents past performance.
              Past performance is not a guarantee of future results. Investment
              return and value of the Fund shares will fluctuate so that an
              investor&apos;s shares, when sold, may be worth more or less than
              their original cost. Current performance may be lower or higher
              than performance data quoted. Shares are bought and sold at market
              price (not NAV) and are not individually redeemed from the Fund.
              Total Returns (Net Asset Value) are calculated using the daily
              4:00pm net asset value (NAV). Through July 31, 2020, Market Price
              returns are based on the midpoint of the bid/ask spread for fund
              shares at market close (typically 4 pm ET). Beginning with August
              31, 2020 month-end performance, Market Price returns are based on
              closing prices reported by the fund&apos;s primary listing
              exchange (typically 4 pm ET close). Returns over one year are
              annualized. Performance results shown reflect expense
              reimbursements (if any), without which the results would have been
              lower.
            </p>

            <p className="Disclaimer-text">
              The amount that the fund&apos;s Market Price is above the reported
              NAV is called the premium. The amount that the fund&apos;s Market
              Price is below the reported NAV is called the discount. The
              vertical axis of the bar chart and the line graph show the premium
              or discount expressed in basis points. The horizontal axis of the
              bar chart and the line graph indicates the number of trading days
              in the period covered by the bar chart and the period(s) covered
              by the line graph. Each bar in the chart shows the number of
              trading days in which the fund traded within the premium/discount
              range indicated. The line graph depicts the frequency and degree
              of fund premiums and discounts between the fund&apos;s Market
              Price and the fund&apos;s NAV per share. Through August 27, 2020,
              the fund&apos;s premium and discount data is based on the midpoint
              of the bid/ask spread for fund shares at market close (typically 4
              pm ET) and the fund&apos;s end-of-day NAV. Beginning August 28,
              2020, the fund&apos;s premium and discount data is based on
              closing prices reported by the fund&apos;s primary listing
              exchange (typically 4 pm ET close) and the fund&apos;s end-of-day
              NAV. For funds with less than a full calendar year of investment
              operations, premium/discount data is since the first day of
              secondary market trading of fund shares.
            </p>
          </React.Fragment>
        )}

        {fundGroup === VARIABLE_FUND && (
          // TODO: once we fix HTML in editor, we can use this
          // <div dangerouslySetInnerHTML={{ __html: performanceDisclosure }}>
          // </div>
          <>
            <h5 className="Disclaimer-heading">Performance Disclosure</h5>
            <p className="Disclaimer-text">
              The performance information shown represents past performance and
              is not a guarantee of future results. The investment return and
              principal value of your investments will fluctuate so that your
              shares, when sold, may be worth more or less than their original
              cost. Current performance may be lower or higher than the
              performance information shown. Returns shown assume reinvestment
              of distributions and do not reflect the deduction of taxes that a
              shareholder would pay on fund distributions or the redemption of
              fund shares.
            </p>
            <p className="Disclaimer-text">
              * Returns shown for periods prior to the fund&apos;s share class
              inception date include the returns of the oldest share class of
              the fund, adjusted to reflect higher class-related operating
              expenses, as applicable. In addition, the returns shown include
              the returns of any predecessor to the fund. For certain funds,
              performance reflects returns achieved through an investment
              strategy which materially differs from the strategy currently
              utilized. Click{' '}
              <a href="/investment-products/variable-products/appended-performance">
                here
              </a>{' '}
              for more information.
            </p>
            <VariableFundDisclosure fundName={fundName} />
          </>
        )}

        {fundGroup === CLOSED_END_FUND && (
          <>
            <h5 className="Disclaimer-heading">Performance Disclosure</h5>
            <p className="Disclaimer-text">
              The performance information shown represents past performance and
              is not a guarantee of future results. The investment return and
              principal value of your investments will fluctuate so that your
              shares, when sold, may be worth more or less than their original
              cost. Current performance may be lower or higher than the
              performance information shown. Returns shown are inclusive of
              total annual expenses.
            </p>
          </>
        )}

        {fundGroup === FUTURE_SCHOLAR_529 && (
          <>
            <h5 className="Disclaimer-heading">Performance Disclosure</h5>
            <p className="Disclaimer-text">
              The performance information shown represents past performance and
              is not a guarantee of future results. The investment return and
              principal value of your investments will fluctuate so that your
              shares, when sold, may be worth more or less than their original
              cost. Current performance may be lower or higher than the
              performance information shown.
            </p>
          </>
        )}

        {fundGroup === INTERVAL_FUND && (
          <React.Fragment>
            <h5 className="Disclaimer-heading">Performance Disclosures</h5>
            {hasGrowthOf10K && (
              <p className="Disclaimer-text">
                Growth of $10,000 investment illustration is based on a
                hypothetical $10,000 investment, not including sales charges.
                Had sales charges been included, returns would be lower. All
                results shown assume reinvestment of dividends and capital
                gains.
              </p>
            )}
            <p className="Disclaimer-text">
              Performance data shown represents past performance and is not a
              guarantee of future results. The investment return and principal
              value of an investment will fluctuate so that shares, when
              redeemed, may be worth more or less than their original cost.
              Current performance may be lower or higher than the performance
              data shown. Returns shown assume reinvestment of distributions and
              do not reflect the deduction of taxes that a shareholder would pay
              on fund distributions or the redemption of fund shares.
            </p>
            <p className="Disclaimer-text">
              * Returns shown for periods prior to the fund&apos;s share class
              inception date include the returns of the oldest share class of
              the fund, adjusted to reflect higher class-related operating
              expenses, as applicable. In addition, the returns shown include
              the returns of any predecessor to the fund. For certain funds,
              performance reflects returns achieved through an investment
              strategy which materially differs from the strategy currently
              utilized. Click{' '}
              <a
                className="Link"
                href="/investment-products/mutual-funds/appended-performance/"
              >
                here
              </a>{' '}
              for more information.
            </p>
          </React.Fragment>
        )}
      </div>
      <div className="disclaimer u-textNormal u-textSolid u-textSecondary u-marginTop4gu">
        <a href="#performance-disclosures">View disclosures</a>
      </div>
    </div>
  )
}

PerformanceDisclosures.propTypes = {
  fundGroup: PropTypes.string.isRequired,
  performanceDisclosure: PropTypes.string,
}

export default PerformanceDisclosures
